"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var system_1 = require("@mui/system");
var colors_1 = require("../../ThemeProvider/colors");
var useHeaderTheme = function () {
    var _a;
    var breakpoints = (0, system_1.createBreakpoints)({});
    var headerTheme = (0, material_1.createTheme)({
        typography: {
            htmlFontSize: 14,
            fontSize: 14,
            fontFamily: '"Noto Sans", sans-serif',
            fontWeightRegular: 500,
        },
        palette: {
            primary: {
                main: colors_1.tannerBlack,
            },
            secondary: {
                main: colors_1.tannerWhite,
            },
        },
        components: {
            MuiButton: {
                styleOverrides: {
                    root: {
                        textTransform: 'none',
                        fontSize: 14,
                        fontWeight: 700,
                    },
                },
            },
            MuiDrawer: {
                styleOverrides: {
                    paper: {
                        width: 280,
                    },
                },
            },
            MuiIconButton: {
                defaultProps: {
                    disableTouchRipple: true,
                },
                styleOverrides: {
                    root: {
                        color: colors_1.tannerBlack,
                        fontSize: 16,
                    },
                    colorSecondary: {
                        color: colors_1.tannerWhite,
                        '&:hover': {
                            backgroundColor: colors_1.tannerGray['800'],
                        },
                        '&:active': {
                            opacity: 0.5,
                        },
                    },
                },
            },
            MuiSvgIcon: {
                defaultProps: { fontSize: 'inherit', color: 'inherit' },
            },
            MuiTabs: {
                defaultProps: {
                    indicatorColor: 'secondary',
                    textColor: 'secondary',
                },
                styleOverrides: {
                    indicator: {
                        height: 5,
                    },
                },
            },
            MuiTab: {
                defaultProps: {
                    disableTouchRipple: false,
                },
                styleOverrides: {
                    root: (_a = {
                            fontWeight: 700,
                            fontSize: 14,
                            height: 56,
                            textTransform: 'none'
                        },
                        _a[breakpoints.up('sm')] = {
                            minWidth: 50,
                        },
                        _a['&:hover'] = {
                            backgroundColor: colors_1.tannerGray['800'],
                        },
                        _a),
                    textColorSecondary: {
                        color: colors_1.tannerWhite,
                    },
                },
            },
            MuiSkeleton: {
                styleOverrides: {
                    root: {
                        backgroundColor: 'rgba(200,200,200,0.25)',
                    },
                },
            },
            MuiTypography: {
                styleOverrides: {
                    body1: {
                        fontSize: 14,
                    },
                },
            },
            MuiAutocomplete: {
                styleOverrides: {
                    inputRoot: {
                        flexWrap: 'initial',
                        padding: 0,
                        '& .MuiAutocomplete-input': {
                            minWidth: 0,
                        },
                    },
                    input: {
                        fontSize: 14,
                        '@media screen and (min-width: 760px)': {
                            color: colors_1.tannerWhite,
                        },
                    },
                    listbox: {
                        padding: 8,
                        '& .MuiAutocomplete-option': {
                            '@media screen and (min-width: 760px)': {
                                '&.Mui-focused': {
                                    backgroundColor: colors_1.tannerGray['900'],
                                },
                                '&.Mui-focusVisible': {
                                    outline: "3px solid ".concat(colors_1.tannerBlue['300']),
                                    outlineOffset: 3,
                                    transition: 'outline-offset 150ms',
                                    borderRadius: 3,
                                },
                            },
                        },
                    },
                    option: {
                        '&.Mui-focused': {
                            borderRadius: '3px',
                        },
                    },
                    paper: {
                        borderTopLeftRadius: 0,
                        borderTopRightRadius: 0,
                        margin: 0,
                        '@media screen and (min-width: 769px)': {
                            backgroundColor: colors_1.tannerGray['800'],
                        },
                    },
                },
            },
        },
    });
    return headerTheme;
};
exports.default = useHeaderTheme;
//# sourceMappingURL=useHeaderTheme.js.map